import {styled} from '@mui/material/styles'
import PropTypes from 'prop-types'

const GreenBarLine = (props) => {
  GreenBarLine.propTypes = {
    title: PropTypes.string
  }
  return (
    <div>
      <StyledBarLine title={props.title} />
    </div>
  )
}

const StyledBarLine = styled('hr', {shouldForwardProp: (prop) => prop !== 'title'})(({theme, title}) => ({
  color: theme.palette.hpAccentYellowGreen,
  backgroundColor: theme.palette.hpAccentYellowGreen,
  height: 5,
  width: 67,
  border: theme.spacing(1),
  float: title ? 'left' : ''
}))

export default GreenBarLine
